import React from 'react';
import Item from "../../components/list/Item";
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="Monolith to Microservices"
        desc="Evolutionary patterns to Transform Your Monolith"
        image="/images/books/monolith-to-microservices.jpg"
        pageType="book"
        author="Sam Newman"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/monolith-to-microservices.jpg"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                Monolith to Microservices
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Sam Newman</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                This is a great book if you are moving from a monolith to microservices. The first section of the book covers the reasons why you should move or not move to a microservices
                architecture, annd the second part of the book covers different techniques for spliting a monolith.
              </p>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                The second part also covers one of the most tricky part of spliting a monolith and it is the data. Spliting data stores without downtime is a hard problem to solve and this book
                proposes a few options to solve it.
              </p>
            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
